import React, { useState } from "react";
import Box from "@mui/material/Box";
import ClearIcon from "@mui/icons-material/Clear";
import Select from "react-select";
import Modal from "@mui/material/Modal";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FaPlane } from "react-icons/fa";
import { BsPlusLg } from "react-icons/bs";

const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  height: "900px",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "5%",
  paddingRight: "3%",
  zIndex: 9999,
  overflowY: "scroll",
  overflowX: "hidden",

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};

const CrewOptions = [
  { value: "PIC", label: "PIC" },
  { value: "SIC", label: "SIC" },
  { value: "IP", label: "IP" },
  { value: "EP", label: "EP" },
  { value: "LCA", label: "LCA" },
  { value: "Solo", label: "Solo" },
  { value: "Dual Received", label: "Dual Received" },
  { value: "Student Pilot", label: "Student Pilot" },
];

const OperationOptions = [
  { value: "Part 141", label: "Part 141" },
  { value: "Part 61", label: "Part 61" },
  { value: "Part 91", label: "Part 91" },
  { value: "Part 121", label: "Part 121" },
  { value: "Part 135", label: "Part 135" },
  { value: "Military", label: "Military" },
];

const BodyTypeOptions = [
  { value: "Wide Body", label: "Wide Body" },
  { value: "Narrow Body", label: "Narrow Body" },
  { value: "Commuter", label: "Commuter" },
  { value: "Regional", label: "Regional" },
]

const EngineTypeOptions = [
  { value: "Piston Single Engine", label: "Piston Single Engine" },
  { value: "Piston Multi Engine", label: "Piston Multi Engine" },
  { value: "Turboprop Engine", label: "Turboprop Engine" },
  { value: "Turbojet Engine", label: "Turbojet Engine" },
  { value: "Turbofan Engine", label: "Turbofan Engine" },
  { value: "Turboshaft Engine", label: "Turboshaft Engine" },
]
interface CustomField {
  name: string;
  value: string;
  _id: string;
}



const ViewAircraftModal = ({
  isViewModalOpen,
  handleCloseModal,
  selectedAircraftData,
}: {
  isViewModalOpen: boolean;
  handleCloseModal: () => void;
  selectedAircraftData: any;
  // setEditModalOpen: (isOpen: boolean) => void;
}) => {
  console.log("Selected Aircraft Data:", selectedAircraftData);
  // const [userName, setUserName] = React.useState("");
  const [registrationNo, setRegistrationNo] = React.useState(selectedAircraftData?.registrationNo);
  const [formSubmit, setFormSubmit] = React.useState(false);
  const [aircarftid, setAircarftid] = React.useState(selectedAircraftData?.ident);
  const [aircraftEngineCount, setAircraftEngineCount] = React.useState(selectedAircraftData?.aircraftEngineType);
  const [aircrafttype, setAircrafttype] = React.useState(selectedAircraftData?.model);
  const [bodytype, setBodytype] = React.useState(selectedAircraftData?.bodyType);
  const [enginetype, setEnginetype] = React.useState(selectedAircraftData?.engineType);
  const [defaultValue, setDefaultValue] = React.useState(selectedAircraftData?.defaultValue);
  const [favorite, setFavorite] = React.useState(selectedAircraftData?.favorite);
  const [complex, setComplex] = React.useState(selectedAircraftData?.complex);
  const [pressurized, setPressurized] = React.useState(selectedAircraftData?.pressurized);
  const [retractable, setRetractable] = React.useState(selectedAircraftData?.retractable);
  const [highPerformance, setHighPerformance] = React.useState(selectedAircraftData?.highPerformance);
  const [amphibian, setAmphibian] = React.useState(selectedAircraftData?.amphibian);
  const [skis, setSkis] = React.useState(selectedAircraftData?.skis);
  const [EFIS, setEFIS] = React.useState(selectedAircraftData?.efis);
  const [fuelInjection, setFuelInjection] = React.useState(selectedAircraftData?.fuelInjection);
  const [tailWheel, setTailWheel] = React.useState(selectedAircraftData?.tailwheel);
  const [aerobatic, setAerobatic] = React.useState(selectedAircraftData?.aerobatic);
  const [experimental, setExperimental] = React.useState(selectedAircraftData?.experimental);
  const [warBird, setWarBird] = React.useState(selectedAircraftData?.warbird);
  const [fighterHeavy, setFighterHeavy] = React.useState(selectedAircraftData?.fighterHeavy);
  const [aircraftImage, setImage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [autoLog, setAutoLog] = React.useState<boolean>(selectedAircraftData?.autoLog);
  const [typeOfOperation, setTypeOfOperation] = React.useState(selectedAircraftData?.typeOfOperation);
  const [selectedCrewOptions, setSelectedCrewOptions] = useState<any>(selectedAircraftData?.defaultCrewPosition);
  const [landings, setLandings] = useState(selectedAircraftData?.landing);

  const [isCustomFieldEditable, setIsCustomFieldEditable] = useState(false);

  const [selectedFileName, setSelectedFileName] = useState("");
  const [instrumentTimePercentage, setInstrumentTimePercentage] = useState(selectedAircraftData?.instrumentTimePercentage);
  const [approaches, setApproaches] = useState(selectedAircraftData?.approaches);
  const [autoLogFrequency, setAutoLogFrequency] = useState("");
  const [customFields, setCustomFields] = useState<
    { id: number; value: string }[]
  >([]);

  const [customValue, setCustomValue] = useState("");

  React.useEffect(() => {
    setRegistrationNo(selectedAircraftData?.registrationNo);
    setAircarftid(selectedAircraftData?.ident);
    setAircraftEngineCount(selectedAircraftData?.engineType);
    setAircrafttype(selectedAircraftData?.model);
    setBodytype(selectedAircraftData?.bodyType);
    setEnginetype(selectedAircraftData?.engineType);
    setDefaultValue(selectedAircraftData?.defaultValue);
    setFavorite(selectedAircraftData?.favorite);
    setComplex(selectedAircraftData?.complex);
    setPressurized(selectedAircraftData?.pressurized);
    setRetractable(selectedAircraftData?.retractable);
    setHighPerformance(selectedAircraftData?.highPerformance);
    setAmphibian(selectedAircraftData?.amphibian);
    setSkis(selectedAircraftData?.skis);
    setEFIS(selectedAircraftData?.efis);
    setFuelInjection(selectedAircraftData?.fuelInjection);
    setTailWheel(selectedAircraftData?.tailwheel);
    setAerobatic(selectedAircraftData?.aerobatic);
    setExperimental(selectedAircraftData?.experimental);
    setWarBird(selectedAircraftData?.warbird);
    setFighterHeavy(selectedAircraftData?.fighterHeavy);
    setSelectedCrewOptions(selectedAircraftData?.defaultCrewPosition);
    setAutoLog(selectedAircraftData?.autoLog);
    setLandings(selectedAircraftData?.landing);
    setInstrumentTimePercentage(selectedAircraftData?.instrumentTimePercentage);
    setApproaches(selectedAircraftData?.approaches);
    setTypeOfOperation(selectedAircraftData?.typeOfOperation);
  }, [selectedAircraftData]);

  return (
    <Modal open={isViewModalOpen} onClose={handleCloseModal}>
      <Box sx={style}>
        <div className="clear_icon">
          <ClearIcon
            style={{ marginTop: "2%" }}
            onClick={handleCloseModal}
          />
        </div>
        <div>
          <h2 className="heading2">View Aircraft</h2>
          <p className="heading4 secondary" style={{ fontWeight: "600" }}>
            Aircraft Details
          </p>
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <label className="heading5" style={{ marginBottom: "5px" }}>
              Registeration number
            </label>
          </div>
          {error && (
            <div
              style={{ color: "red", marginTop: "4px" }}
              className="heading6"
            >
              {error}
            </div>
          )}{" "}
          {/* Error display */}
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="add_group">
              <input
                type="text"
                placeholder="UTF3235"
                className="add_input"
                id="registeration_no"
                value={registrationNo}
              />
              {/* {loading && <CircularProgress size={20} />}{" "} */}
              {/* Loading spinner */}
            </div>

            {/* Image Upload */}
            <div
              style={{
                border: "none !important",
                padding: 0,
                paddingLeft: "3px",
                paddingRight: "3px",
                width: "36%",
                marginRight: "10%",
                display: "flex",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <input
                type="file"
                accept="image/*"
                id="aircraftImage"
                name="aircraftImage"
                style={{ display: "none" }}
              />

              {selectedFileName ? (
                <>
                  <label
                    htmlFor="aircraftImage"
                    style={{
                      cursor: "pointer",
                      padding: 0,
                      margin: 0,
                      color: "#00AF80",
                      marginRight: "4px",
                    }}
                  >
                    <CloudUploadIcon style={{ fontSize: "40px" }} />
                  </label>

                  <span style={{ fontSize: "10px" }}>
                    {selectedFileName}
                  </span>
                </>
              ) : (
                <label
                  htmlFor="aircraftImage"
                  style={{
                    cursor: "pointer",
                    padding: 0,
                    margin: 0,
                    color: "#00AF80",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CloudUploadIcon style={{ fontSize: "40px" }} />
                  <span className="heading4" style={{ marginLeft: "4px" }}>
                    Upload Image
                  </span>
                </label>
              )}
            </div>

            {/* Image Upload end*/}
          </div>
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <label className="heading5" style={{ marginBottom: "5px" }}>
              Aircraft ID
            </label>
            <label
              className="heading5"
              style={{ marginBottom: "5px", marginRight: "30%" }}
            >
              Aircraft Type
            </label>
          </div>
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="add_group">
              <input
                type="text"
                value={aircarftid}
                placeholder="ID"
                className="add_input"

              />
            </div>
            <div className="add_group" style={{ marginRight: "10%" }}>
              <input
                value={aircrafttype}
                type="text"
                placeholder="Type"
                className="add_input"
              />
            </div>
          </div>
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="add_span">
              <input
                type="checkbox"
                className="add_checkbox"
                id="defaultValue"
                name="defualt"
                checked={defaultValue}
              />
              <label className="heading4">Default</label>
            </div>
            <div className="add_span" style={{ marginRight: "30%" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="favorite"
                name="favorite"
                checked={favorite}
              />
              <label className="heading4">Favorite</label>
            </div>
          </div>
          <div
            className="f-flex"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: "22%",
            }}
          >
            <label className="heading5" style={{ marginBottom: "5px" }}>
              Default Crew Position
            </label>
            <label className="heading5" style={{ marginBottom: "5px" }}>
              Type of Operations
            </label>
          </div>
          <div className="f-flex">
            <div style={{ flex: "50%", padding: 0, margin: 0 }}>
              <Select
                isMulti
                // options={CrewOptions}
                value={selectedCrewOptions}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginBottom: "5%",
                    maxWidth: "80%",
                    fontSize: "14px"
                  }),
                  clearIndicator: () => ({ display: "none" }), // Hide the clear indicator (X icon)
                }}
              />
            </div>

            <div style={{ flex: "50%" }}>
              <Select
                id="typeOfOperation"
                name="typeOfOperation"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginBottom: "5%",
                    maxWidth: "80%",
                    fontSize: "14px"
                  }),
                  dropdownIndicator: () => ({
                    display: 'none', // Hide the dropdown indicator
                  }),
                  menu: (provided) => ({
                    ...provided,
                    display: 'none', // Hide the options menu
                  }),
                }}
                defaultValue={{ label: typeOfOperation, value: typeOfOperation }}
              />
            </div>
          </div>
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <label className="heading5" style={{ marginBottom: "5px", marginTop: "2%" }}>
              Aircraft Body Type
            </label>
            <label
              className="heading5"
              style={{ marginBottom: "5px", marginRight: "30%", marginTop: "2%" }}
            >
              Engine Type
            </label>
          </div>
          <div
            className="f-flex"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ flex: "50%" }}>
              <Select
                id="BodyType"
                name="BodyType"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginBottom: "8%",
                    maxWidth: "80%",
                    fontSize: "14px"
                  }),
                  dropdownIndicator: () => ({
                    display: 'none', // Hide the dropdown indicator
                  }),
                  menu: (provided) => ({
                    ...provided,
                    display: 'none', // Hide the options menu
                  }),
                }}
                defaultValue={{ label: bodytype, value: bodytype }}
              />
            </div>
            <div style={{ flex: "50%" }}>
              <Select
                id="EngineType"
                name="EngineType"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginBottom: "8%",
                    maxWidth: "80%",
                    fontSize: "14px"
                  }),
                  dropdownIndicator: () => ({
                    display: 'none', // Hide the dropdown indicator
                  }),
                  menu: (provided) => ({
                    ...provided,
                    display: 'none', // Hide the options menu
                  }),
                }}
                defaultValue={{ label: enginetype, value: enginetype }}
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="add_span" style={{ flexGrow: "1" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="complex"
                name="complex"
                checked={complex}
              />
              <label className="heading4">Complex</label>
            </div>
            <div
              className="add_span"
              style={{ flexGrow: "1", marginLeft: "6%" }}
            >
              <input
                type="checkbox"
                className="add_checkbox"
                id="pressurized"
                name="pressurized"
                checked={pressurized}
              />
              <label className="heading4">Pressurized</label>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div className="add_span" style={{ flexGrow: "1" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="retractable"
                name="retractable"
                checked={retractable}
              />
              <label className="heading4">Retractable</label>
            </div>
            <div
              className="add_span"
              style={{ flexGrow: "1", marginLeft: "12%" }}
            >
              <input
                type="checkbox"
                className="add_checkbox"
                id="highPerformance"
                name="highPerformance"
                checked={highPerformance}
              />
              <label className="heading4">High Performance</label>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div className="add_span" style={{ flexGrow: "1" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="amphibian"
                name="amphibian"
                checked={amphibian}
              />
              <label className="heading4">Amphibian</label>
            </div>
            <div
              className="add_span"
              style={{ flexGrow: "1", marginRight: "12%" }}
            >
              <input
                type="checkbox"
                className="add_checkbox"
                id="skis"
                name="skis"
                checked={skis}
              />
              <label className="heading4">Skis</label>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div className="add_span" style={{ flexGrow: "2" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="EFIS"
                name="EFIS"
                checked={EFIS}
              />
              <label className="heading4">EFIS</label>
            </div>
            <div
              className="add_span"
              style={{ flexGrow: "2", marginLeft: "16%" }}
            >
              <input
                type="checkbox"
                className="add_checkbox"
                id="fuelInjection"
                name="fuelInjection"
                checked={fuelInjection}
              />
              <label className="heading4">Fuel Injection</label>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div className="add_span" style={{ flexGrow: "2" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="tailWheel"
                name="tailWheel"
                checked={tailWheel}
              />
              <label className="heading4">Tailwheel</label>
            </div>
            <div
              className="add_span"
              style={{ flexGrow: "2", marginLeft: "1%" }}
            >
              <input
                type="checkbox"
                className="add_checkbox"
                id="aerobatic"
                checked={aerobatic}
              />
              <label className="heading4">Aerobatic</label>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div className="add_span" style={{ flexGrow: "2" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="experimental"
                checked={experimental}
              />

              <label className="heading4">Experimental</label>
            </div>
            <div
              className="add_span"
              style={{ flexGrow: "2", marginRight: "8%" }}
            >
              <input
                type="checkbox"
                className="add_checkbox"
                id="warBird"
                name="warbird"
                checked={warBird}
              />
              <label className="heading4">Warbird</label>
            </div>
          </div>
          <div
            className="add_span"
            style={{ flexGrow: "2", marginRight: "8%" }}
          >
            <input
              type="checkbox"
              className="add_checkbox"
              id="warBird"
              name="warbird"
              checked={fighterHeavy}
            />
            <label className="heading4">Fighter Heavy</label>
          </div>
          {/* Auto Log */}
          <div className="add_span" style={{ flexGrow: "2" }}>
            <label
              className="heading4 secondary"
              style={{ fontWeight: "600" }}
            >
              Autolog
            </label>
          </div>
          <div>
            <div className="add_span" style={{ flexGrow: "2" }}>
              <input
                type="checkbox"
                className="add_checkbox"
                id="autoLog"
                name="autoLog"
                checked={autoLog}
              />
              <label className="heading4">Auto Log</label>
            </div>

            {autoLog && (
              <div
                style={{
                  background: "#F8FAFB",
                  padding: "6px 5px 3px 5px",
                  width: "90%"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <div className="add_span">
                    <input
                      type="checkbox"
                      className="add_checkbox"
                      id="landings"
                      name="landings"
                      checked={landings}
                    />
                    <label className="heading4">Landings</label>

                  </div>
                  {/* <div
                    className="heading4"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                      padding: "0px 20px 0px 20px",
                    }}
                  >
                    <label>
                      <input
                        type="radio"
                        name="flightOption"
                        value="everyOtherFlight"
                        checked={autoLogFrequency === "everyOtherFlight"}

                      />
                      Every other Flight
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="flightOption"
                        value="always"
                        checked={autoLogFrequency === "always"}

                      />
                      Always
                    </label>
                  </div> */}
                </div>
                <div
                  className="add_span"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div>
                    <label
                      className="heading4"
                      htmlFor="instrumentTimePercentage"
                    >
                      <span style={{ marginLeft: "25px" }}>
                        {" "}
                        Instrument Time %:
                      </span>
                    </label>

                    <input
                      className="add_input"
                      type="text"
                      id="instrumentTimePercentage"
                      name="instrumentTimePercentage"
                      style={{ width: "60%", height: "100%" }}
                      placeholder="Enter"
                      value={instrumentTimePercentage}
                    />
                  </div>
                  <div>
                    <label className="heading4" htmlFor="approaches">
                      <span style={{ marginLeft: "5%" }}>Approaches:</span>
                    </label>
                    <input
                      className="add_input"
                      type="text"
                      id="approaches"
                      name="approaches"
                      style={{ width: "70%", height: "100%" }}
                      placeholder="Enter"
                      value={approaches}
                    />
                  </div>
                </div>

                <div
                  className="heading4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    padding: "0px 20px 0px 20px",
                  }}
                >
                  <label>
                    <input
                      type="radio"
                      name="flightOption"
                      value="everyOtherFlight"
                      checked={autoLogFrequency === "everyOtherFlight"}

                    />
                    Every other Flight
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="flightOption"
                      value="always"
                      checked={autoLogFrequency === "always"}

                    />
                    Always
                  </label>
                </div>
              </div>
            )}
          </div>
          {/* Auto Log  End*/}
          {/* Custom Field */}
          {/* <div className="add_span" style={{ flexGrow: "2" }}>
                <label
                  className="heading4 secondary"
                  style={{ fontWeight: "600" }}
                >
                  Custom Fields
                </label>
              </div>
              <div style={{ height: "100%" }}>
                <button
                  className="add_flight_btn"
                  style={{ marginBottom: "15px", width: "35%" }}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleCustomField();
                    addCustomField();
                  }}
                >
                  <BsPlusLg /> Add Custom Field
                </button>

                {customFields.map((field, index) => {
                  const isFieldEmpty = field.value.trim() === "";

                  return (
                    <div
                      key={field.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: "#F8FAFB",
                        justifyContent: "space-between",
                        paddingLeft: "2%",
                        paddingRight: "2%",
                        borderRadius: "10px",
                        marginBottom: "5%",
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          width: "100%",
                          position: "relative",
                        }}
                      >
                        {isCustomFieldEditable ||
                        index === customFields.length - 1 ? (
                          <input
                            style={{
                              height: "100%",
                              border: "none",
                              fontSize: "14px",
                              width: "100%",
                              padding: "4%",
                              maxHeight: "100%",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              background: "transparent",
                              outline: "none",
                            }}
                            type="text"
                            id="CustomFieldname"
                            placeholder="Custom Field"
                            value={field.value}
                            onChange={(e) => {
                              setCustomFields(
                                customFields.map((item, i) =>
                                  i === index
                                    ? { ...item, value: e.target.value }
                                    : item
                                )
                              );
                            }}
                            onBlur={() => {
                              if (isFieldEmpty) {
                                setCustomFields(
                                  customFields.map((item, i) =>
                                    i === index
                                      ? { ...item, value: "Custom Field" }
                                      : item
                                  )
                                );
                                setIsCustomFieldEditable(false);
                              }
                            }}
                          />
                        ) : (
                          <div
                            className="heading4"
                            onClick={() => setIsCustomFieldEditable(true)}
                          >
                            {field.value || "Custom Field"}
                          </div>
                        )}
                      </div>
                      <input
                        style={{ marginRight: "8%", padding: "1.2%" }}
                        type="string"
                        placeholder="Enter the custom value"
                        value={customValue}
                        onChange={(e) => setCustomValue(e.target.value)}
                      />
                      <button
                        onClick={() => removeCustomField(field.id)}
                        style={{
                          border: "none",
                          background: "none",
                          cursor: "pointer",
                        }}
                      >
                        <DeleteOutlineSharpIcon style={{ color: "red" }} />
                      </button>
                    </div>
                  );
                })}
              </div> */}
          {/* Custom Field end */}
          <button
            onClick={handleCloseModal}
            className="add_btn"
            style={{ float: "right", marginRight: "10%", marginTop: "5%" }}
          >
            <span>Close</span>
          </button>
          <br />
          <br />
          <br />

        </div>
      </Box>
    </Modal>
  );
};

export default ViewAircraftModal;
